import { render, staticRenderFns } from "./Factory-supplier.vue?vue&type=template&id=52f17e8a&scoped=true&"
import script from "./Factory-supplier.vue?vue&type=script&lang=js&"
export * from "./Factory-supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f17e8a",
  null
  
)

export default component.exports